(() => {
  if (customElements.get('metalnook-installments')) return;
  class MetalnookInstallments extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.onContent = () => this.connectStore();
      window.addEventListener('contentLoaded', this.onContent);
      this.connectStore();
      // MEM loads asynchronously; stop discovery after its documented readiness window.
      let attempts = 0;
      this.timer = setInterval(() => {
        if (this.connectStore() || ++attempts >= 60) clearInterval(this.timer);
      }, 250);
    }
    connectStore() {
      if (this.unsubscribe) return true;
      const store = window.personalizationPreviewStore;
      if (!store?.subscribe || !store?.getState || !this.product?.querySelector('.mem_widget_ui')) return false;
      const sync = () => {
        const state = store.getState().globalReducer;
        if (String(state?.shopifyProductData?.id) !== this.dataset.productId) return;
        const variant = state.selectedVariant;
        if (!variant?.id) return;
        const form = this.querySelector('form');
        const terms = form?.querySelector('shopify-payment-terms');
        const input = form?.querySelector('input[name="id"]');
        if (!input || !terms) return;
        // Use only Shopify-issued variant metadata. Never fabricate financing prices.
        let metadata;
        try { metadata = JSON.parse(terms.getAttribute('shopify-meta')); } catch { return; }
        const known = metadata?.variants?.find(item => String(item.id) === String(variant.id));
        const matches = known && Math.round(Number(known.full_price_amount) * 100) === Math.round(Number(variant.price));
        this.hidden = !matches;
        if (!matches) return;
        const id = String(variant.id);
        if (input.value !== id) {
          input.value = id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (terms.getAttribute('variant-id') !== id) terms.setAttribute('variant-id', id);
      };
      this.unsubscribe = store.subscribe(sync);
      sync();
      return true;
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.unsubscribe?.();
      this.unsubscribe = null;
      window.removeEventListener('contentLoaded', this.onContent);
    }
  }
  customElements.define('metalnook-installments', MetalnookInstallments);
})();
